import React from "react";
import styled from "styled-components";
//
export default styled.div`
  margin: 0 auto;
  max-width: 2400px;
  padding: 0 2vw 6rem;

  @media (min-width: 544px) {
    padding: 0 2vw 10vh;
  }
`;
